import { z } from "zod";

export const postFileAnnotationsExistSchema = z.object({
	fileIds: z.array(z.uuid()),
});

export type PostFileAnnotationsExistSchema = z.infer<typeof postFileAnnotationsExistSchema>;
